export const GetProductsSelectDiscount = (data) => {
  return data.reduce((a, o) => (a.push({
    label: o.product.name,
    value: o.id
  }), a), []);
}